import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from './App';

import { unregister } from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const sentryEnv = process.env.REACT_APP_SENTRY_ENV_NAME || '';
if (sentryEnv && sentryEnv !== 'dev') {
  Sentry.init({
    dsn: "https://58aa4535cd9c4bd1ba991bb06f1b534d@o4504730772897792.ingest.sentry.io/4504730774011904",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: sentryEnv
  });
}



ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

  unregister();
// registerServiceWorker(); //for some reason this blocked all server requests in a deployed enviornment



// WEBPACK FOOTER //
// ./src/index.js